import type { Product, SearchSuggestions } from "mws-ts-v2-sdk";

export enum SearchResultTypes {
  TopResults = "topResults",
  Teams = "teams",
  Events = "events",
  Products = "products",
  Leagues = "leagues",
  Other = "other",
}

export const auctionPlatformSearchTabs = [
  SearchResultTypes.TopResults,
  SearchResultTypes.Teams,
  SearchResultTypes.Events,
  SearchResultTypes.Products,
  SearchResultTypes.Leagues,
  SearchResultTypes.Other,
];

export const nonAuctionPlatformSearchTabs = [
  SearchResultTypes.TopResults,
  SearchResultTypes.Teams,
  SearchResultTypes.Products,
  SearchResultTypes.Other,
];

export type CategorySearchResultTypes =
  | SearchResultTypes.Teams
  | SearchResultTypes.Leagues
  | SearchResultTypes.Other;

export enum CategoryTrackingMapTypes {
  "teams" = "team",
  "leagues" = "league",
  "other" = "other",
}

export type QuickSearchResults = {
  products: Product[];
  suggestions: SearchSuggestions[];
  searchTerm: string;
  hasResults: boolean;
};
